import { Icon } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../components/TableContent';
import { CryptoAssetsQueryItem } from '../../../../../store/customerAssetDetail/types';
import { IDynamicProductSearchItem } from '../_dynamic';

import { tableHead } from './constants';

const ProductSearchItem = ({ item, product }: IDynamicProductSearchItem<CryptoAssetsQueryItem>) => {
  const getVariationIcon = () => {
    if (item.variationType === 'positive') {
      return <Icon name="ArrowUp" size="xxs" color={Color['feedback.success.default']} />;
    }
    if (item.variationType === 'negative') {
      return <Icon name="ArrowDown" size="xxs" color={Color['feedback.error.default']} />;
    }
    return null;
  };

  const getFlex = (index: number) => {
    const currentHead = tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  return (
    <TableContent direction="row" space={0} py={Spacing['stack.xxs']} px={Spacing['inline.xxxs']}>
      <Box
        position={'absolute'}
        top={0}
        left={0}
        bottom={0}
        w={'4px'}
        backgroundColor={Color[product.colorNormalized]}
        borderTopLeftRadius={'full'}
        borderBottomLeftRadius={'full'}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{item.productNameNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{item.quantityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{item.positionNormalized.toString()}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{item.resultNormalized.toString()}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn
        flex={getFlex(4)}
        flexDirection="row"
        alignItems="center"
        space={Spacing['inline.nano']}>
        {getVariationIcon()}
        <TableContentItemText>{item.profitabilityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{item.valueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>{item.averagePriceNormalized}</TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};

export default React.memo(ProductSearchItem);
